import { useEffect, useState } from 'react';

import { ColumnField, TableColumnsButton } from '../../../../components/TableColumnsButton';
import { TableColumn } from '../../../../context/shared/tableColumns';
import { SUPERVISORS_DEFAULT_TABLE_COLUMNS, SupervisorsTableColumn } from '../../../../context/supervisor/tableColumns';
import { Supervisor } from '../../../../domain/supervisor/Supervisor';
import { useSetSupervisorsColumns } from '../../../../hooks/supervisor/useSetSupervisorsColumns';

type SupervisorsListColumnsButtonProps = {
  id: string;
  disabled?: boolean;
};

export const SupervisorsListColumnsButton = ({ id, disabled }: SupervisorsListColumnsButtonProps) => {
  const { run: setTableColumns, tableColumns } = useSetSupervisorsColumns();
  const [columns, setColumns] = useState<ColumnField[]>([]);

  useEffect(() => {
    const defaultIdentifiers = SUPERVISORS_DEFAULT_TABLE_COLUMNS.map((tableColumn) => tableColumn.identifier);

    // Setting all the default column fields (excluding the custom fields).
    const defaultColumns = tableColumns
      .filter((tableColumn: SupervisorsTableColumn) => defaultIdentifiers.includes(tableColumn.identifier))
      .map((tableColumn: SupervisorsTableColumn) => ({
        id: tableColumn.identifier,
        customField: false,
        intlId: `supervisors.data.details.${tableColumn.identifier}`,
        enabled: tableColumn.displayable,
      }));

    setColumns(defaultColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setColumns, tableColumns]);

  return (
    <TableColumnsButton
      id={id}
      disabled={disabled}
      tableColumns={columns}
      onChange={(columnField: ColumnField, value: boolean) => {
        const newColumnsObject = tableColumns.map((tableColumn: SupervisorsTableColumn) => {
          if (tableColumn.identifier === columnField.id) {
            return {
              ...tableColumn,
              displayable: value,
            };
          }
          return tableColumn;
        }) as TableColumn<any, Supervisor>[];
        setTableColumns(newColumnsObject);
      }}
    />
  );
};
